import React, { useEffect, useRef, useState } from 'react';
import { Form, Checkbox, Space, Input } from 'antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import { useParams } from 'react-router-dom';
import '../SurveyAnswer.less';

// 多选题
const Multiple = ({ body, required, id, optionList, num, minSelect, maxSelect, form, initForm }: { body?: string; required?: boolean; optionList?: Array<string>; num?: number; id?: number; minSelect?: number; maxSelect?: number; form?: any; initForm?: any }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const [value, setValue] = useState<any>([]);
    const [isShowTip, setIsShowTip] = useState(false);
    const [optionArr, setOptionArr] = useState([]);
    const blankRef = useRef<any>(null);

    const onChange = (target: CheckboxValueType[]) => {
        if (blankRef.current && target && target.length && !target.includes(blankRef.current)) {
            form.setFieldValue([`${id}-2`, 1], '');
        }
        setValue(target);
    };

    // 问卷回显缓存
    useEffect(() => {
        let formData = localStorage.getItem('initFormData');
        if (formData) {
            let val = JSON.parse(formData)[`${id}-2`];
            if (val && val[0] && maxSelect && val[0].length === maxSelect) {
                setIsDisabled(true);
            }
            if (val && val.length && val[0]) {
                setValue(val[0]);
            }
        }
    }, []);

    useEffect(() => {
        if (optionList && optionList.length) {
            let arrnoBlank: any = optionList.filter((item: any) => !item.isBlank);
            let arrBlank = optionList.filter((item: any) => item.isBlank);
            setOptionArr(arrnoBlank.concat(arrBlank));

            let arr = optionList.filter((it: any) => it.selected);
            let answer: any = [];
            answer[0] = [];
            if (arr && arr.length) {
                arr.forEach((el: any) => {
                    answer[0].push(el.id);
                    answer[1] = el.exContent;
                });
                if (answer[0] && maxSelect && answer[0].length === maxSelect) {
                    setIsDisabled(true);
                }
            }

            if (initForm) {
                let val = initForm[`${id}-2`];
                if (val && val.length && val[0]) {
                    setValue(val[0]);
                }
            } else {
                setValue(answer[0]);
            }
        }
    }, [optionList, initForm]);

    useEffect(() => {
        if (optionList && optionList.length) {
            let arrBlank: any = optionList.filter((item: any) => item.isBlank);

            if (arrBlank && arrBlank.length) {
                blankRef.current = arrBlank[0].id;
                if (value && value.length && !value.includes(arrBlank[0].id)) {
                    setIsShowTip(false);
                    form.setFieldValue([`${id}-2`, 1], '');
                }
            }
        }
    }, [value, optionList]);

    return (
        <>
            <Form.Item
                name={[`${id}-2`, 0]}
                rules={[
                    {
                        required,
                        validator: async (rule, value) => {
                            console.log(value, '999');
                            if (required) {
                                if (!value || (value && value.length === 0)) {
                                    setIsDisabled(false);
                                    throw '该题为必答题，请作答后提交。';
                                } else if (minSelect && value && value.length < minSelect) {
                                    setIsDisabled(false);
                                    throw '请您按题目要求作答';
                                } else if (maxSelect && value && value.length === maxSelect) {
                                    setIsDisabled(true);
                                } else {
                                    setIsDisabled(false);
                                }
                            } else {
                                if (minSelect && value && value.length && value.length < minSelect) {
                                    setIsDisabled(false);
                                    throw '请您按题目要求作答';
                                } else if (maxSelect && value && value.length && value.length === maxSelect) {
                                    setIsDisabled(true);
                                } else {
                                    setIsDisabled(false);
                                }
                            }
                        },
                    },
                ]}
                label={<div className="label-flex" style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}
            >
                <Checkbox.Group style={{ width: '100%' }} value={value} onChange={onChange}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        {optionArr && optionArr.length
                            ? optionArr.map((option: any, index) => (
                                  <div key={option.id}>
                                      {option.isBlank === 0 ? (
                                          <Checkbox value={option.id} disabled={isDisabled && value && value.indexOf(option.id) === -1}>
                                              {option.content}
                                          </Checkbox>
                                      ) : (
                                          <Checkbox value={option.id} disabled={isDisabled && value && value.indexOf(option.id) === -1} style={{ width: '100%' }}>
                                              <div className="single-topic" style={{ width: '100%' }} key={option.id}>
                                                  <p>{option.content}</p>
                                                  <Form.Item
                                                      name={[`${id}-2`, 1]}
                                                      label=""
                                                      rules={[
                                                          {
                                                              required: value && value.length && value.includes(option.id),
                                                              validator: async (rule, val) => {
                                                                  if (!val && value && value.length && value.includes(option.id)) {
                                                                      setIsShowTip(true);
                                                                      throw '';
                                                                  } else {
                                                                      setIsShowTip(false);
                                                                  }
                                                              },
                                                          },
                                                      ]}
                                                  >
                                                      <Input style={{ marginLeft: 10, borderColor: isShowTip ? 'red' : 'black' }} autoComplete="off" maxLength={200} readOnly={!(value && value.length && value.includes(option.id))} />
                                                  </Form.Item>
                                              </div>
                                          </Checkbox>
                                      )}
                                  </div>
                              ))
                            : null}
                    </Space>
                </Checkbox.Group>
            </Form.Item>
        </>
    );
};

export default Multiple;
